import { View } from './view';

export const PopupMessage = View;
